import type { Agent, Workflow } from "./types";

export function getAgentSchedulePath(agent: Agent) {
  return agent.multi_agent_config_id
    ? `/batch/new?workflow=${encodeURIComponent(agent.multi_agent_config_id)}`
    : `/batch/new?agent=${encodeURIComponent(agent.agent_id)}`;
}

export function getAgentAnalyticsPath(agent: Agent) {
  return agent.multi_agent_config_id
    ? `/analytics?workflow=${encodeURIComponent(agent.multi_agent_config_id)}`
    : `/analytics?agent=${encodeURIComponent(agent.agent_id)}`;
}

export function getWorkflowId(workflow: Workflow) {
  return String(workflow.config_id || workflow.id || "");
}

export function getWorkflowPaths(workflow: Workflow) {
  const workflowId = getWorkflowId(workflow);
  return {
    edit: `/home/create-workflow?multi_agent_config_id=${encodeURIComponent(workflowId)}`,
    schedule: `/batch/new?workflow=${encodeURIComponent(workflowId)}`,
    analytics: `/analytics?workflow=${encodeURIComponent(workflowId)}`,
  };
}
